import { useQuery, useMutation } from '@tanstack/react-query';

import { accountUserDetailKey } from '../../common/queryKeys';
import { setRequestForm } from '../../../../../../lib/common';
import CouponApi from '../../../../../../lib/api/coupon/CouponApi';

export const useUserDetailGenerateCouponQuery = ({ userId, pagination, filterOption, sortOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'couponDetail', 'generate', pagination, filterOption, sortOption, userId],
    async () => {
      const result = await CouponApi.getGenerateSearchCouponList(
        setRequestForm({ pagination, filterOption, sortOption }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          couponList: [],
          totalCnt: 0,
        },
      },
    },
  );
};

export const useCouponListExcelDownloadMutate = ({ options }) => {
  return useMutation(
    [...accountUserDetailKey, 'couponDetail', 'excelDownload'],
    async (payload) => {
      const result = await CouponApi.getCouponListExcelDownload(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
    },
  );
};
